import React from 'react'

import OctaneLogo from '../Images/OctaneLogo'
import { DashboardItemProps } from '../types'
import { FooterGridArea, InfoText, UpdatedAtText } from './Footer.styled'

function Footer({ data }: Readonly<DashboardItemProps>) {
    return (
        <>
            <FooterGridArea componentStyle="grid-area: 2/1/2/2;">
                <OctaneLogo data-testid="octane-logo" />
            </FooterGridArea>
            <FooterGridArea componentStyle="grid-area: 2/2/2/8;">
                <InfoText data-testid="info-text">{data.infoText}</InfoText>
            </FooterGridArea>
            <FooterGridArea componentStyle="grid-area: 2/8/2/9;">
                <UpdatedAtText data-testid="updated-at-text">
                    {data.updatedAtText}
                </UpdatedAtText>
            </FooterGridArea>
        </>
    )
}

export default Footer
